module.exports = __webpack_public_path__ + "img/quicklink-tiles-kia.e13de69a.png";